export const getPageTitle = (title: string) => `${title} | JBI COnNECT+`;
